/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Pickup_UnavailableInputs */

const en_dispatch_pickup_unavailable = /** @type {(inputs: Dispatch_Pickup_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pickup point on this world`)
};

const fr_dispatch_pickup_unavailable = /** @type {(inputs: Dispatch_Pickup_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun point de récupération sur ce world`)
};

const ms_sg2_dispatch_pickup_unavailable = /** @type {(inputs: Dispatch_Pickup_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada titik pengambilan di dunia ini`)
};

/**
* | output |
* | --- |
* | "No pickup point on this world" |
*
* @param {Dispatch_Pickup_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_pickup_unavailable = /** @type {((inputs?: Dispatch_Pickup_UnavailableInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Pickup_UnavailableInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_pickup_unavailable(inputs)
	if (locale === "fr") return fr_dispatch_pickup_unavailable(inputs)
	return ms_sg2_dispatch_pickup_unavailable(inputs)
});